// src/app/meme/[id]/MemePageContent.tsx

'use client';

import { useEffect, useState } from 'react';

interface MemePageContentProps {
  id: string;
}

const MemePageContent: React.FC<MemePageContentProps> = ({ id }) => {
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (id) {
      const url = `${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/generated-memes/${id}`;
      setImageUrl(url);
    }
  }, [id]);

  if (!id) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ textAlign: 'center' }}>
      {imageUrl && (
        <img src={imageUrl} alt='Meme' style={{ maxWidth: '100%' }} />
      )}
    </div>
  );
};

export default MemePageContent;
